import HashIcon from "@redotech/redo-icons/hash-01_filled.svg";
import { AdvancedFilterType } from "@redotech/redo-views-common/advanced-filters/generic-advanced-filter-data";
import { NumberFilterOperator } from "@redotech/redo-views-common/advanced-filters/number-filter";
import { AdvancedTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export function getCustomFieldNumberFilter(
  key: string,
  displayName: string,
): AdvancedTableFilter {
  return {
    type: AdvancedFilterType.NUMBER,
    Icon: HashIcon,
    data: {
      name: key,
      type: AdvancedFilterType.NUMBER,
      value: null,
      operator: NumberFilterOperator.GREATER_THAN,
    },
    displayName,
  };
}
